import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-reportform",
  "use": "icon-reportform-usage",
  "viewBox": "0 0 1194 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1194 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-reportform\"><path d=\"M142.25 284.416h910.166V113.749H142.251v170.667zm568.833 625.835v-512H483.584v512h227.499zm113.834 0h227.499v-512H824.917v512zm-455.168 0v-512H142.251v512h227.498zM85.333 0h1024c31.403 0 56.918 25.43 56.918 56.917v910.166a56.917 56.917 0 01-56.918 56.917h-1024a56.917 56.917 0 01-56.917-56.917V56.917C28.416 25.43 53.931 0 85.333 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol